import { render } from "./distributor_vehicles.vue?vue&type=template&id=1b6ed88c"
import script from "./distributor_vehicles.vue?vue&type=script&lang=js"
export * from "./distributor_vehicles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__